import React, { Component } from 'react';
import { connect } from 'react-redux';
import withAuth from '../../../../components/Services/WithAuth';
import {
    Col, Row, Card, CardBody,
    Button, ModalBody, ModalHeader,
    ModalFooter, Label, Input
} from 'reactstrap';
import ProductDetailsForm from './ProductDetailsForm/index';
import { getCounterpartyType,getreportCategory, getReportFrontCoverList } from '../../../../Analyst/Cases/Create/actions';
import { fetchSectionList, setProductSetup, setCreditSetup, disableProduct,fetchCreditLimitModelList} from '../action';
import { setProductFormData, checkDulpicateProduct, validateProductData } from './helper';
import Modal from '../../../../components/UI/Modal/Modal';
import { setPageView } from '../../../../components/GoogleAnalytics/index';
import { prepareCrawlerData } from './ProductDetailsForm/helper';
import { event } from 'react-ga';
class ProductSetup extends Component {
    constructor() {
        super();
        this.state = {
            productData: [],
            initialValues: {
                counterpartyType: '',
                reportCategory: '',
                reportFrontCover: '',
                name: '',
                price: 0,
                turnAroundTime: '',
                inputValue: "",
                availableCredit: "",
            },
            editProductFlag: false,
            updateFlag: false,
            selectedSectionData: [],
            productDataCount: 0,
            corpId: 1,
            productId: null,
        }
    }
    componentDidMount() {
        setPageView('/Admin/create/corporate/productsetup', document.location.href)
        if (this.props.corporateOnboardingStatus === true && Object.keys(this.props.companySetupOnbaordingData).length > 0) {
            this.props.fetchCounterPartyType();
            this.props.fetchReportCategory();
            this.props.fetchReportFrontCoverList();
            this.props.fetchSectionList();
            this.props.fetchCreditLimitModelList();
            this.props.activeProgressTab('setup-progress-element current');
            if (this.props.incomingProductData) {
                this.setState({
                    productData: [...this.props.incomingProductData],
                    inputValue: this.props.creditData,
                });
            }
            if (this.props.match.params.corporateId) {
                this.setState({
                    availableCredit: this.props.editData.data.credits
                })
            }

        }
        else if (this.props.corporateOnboardingStatus === false && Object.keys(this.props.companySetupOnbaordingData).length > 0) {
            this.props.fetchCounterPartyType();
            this.props.fetchReportCategory();
            this.props.fetchReportFrontCoverList();
            this.props.fetchSectionList();
            this.props.fetchCreditLimitModelList();
            this.props.activeProgressTab('setup-progress-element current');
            this.setState({
                productData: [...this.props.incomingProductData],
                inputValue: this.props.creditData
            });
        } else {
            this.props.history.push('../companysetup');
        }
    }

    deleteProductData = (removableDataindex) => {
        const tempProductData = [...this.state.productData];
        if (this.state.corpId) {
            tempProductData[removableDataindex].enabled = false
        } else {
            tempProductData.splice(removableDataindex, 1);
        }
        this.setState(prevState => ({
            productData: tempProductData,
            updateFlag: !prevState.updateFlag,
            selectedSectionData: [],
            productDataCount: prevState.productDataCount - 1
        }))
        this.toggleModal()
    }

    updateInputValue = (evt) => {
        this.setState({
            inputValue: evt.target.value
        });
    }

    handleDeleteProductData = (event, removableDataindex) => {
        event.preventDefault();
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: <div>
                <ModalHeader>Warning</ModalHeader>
                <ModalBody>
                    <p className="alert alert-danger"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Deleting this product will have impact on scorecard. Are you sure you want to continue?</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.toggleModal}>Cancel</Button>
                    <Button color="info" onClick={() => this.deleteProductData(removableDataindex)}>Ok</Button>
                </ModalFooter>
            </div>
        }))
    }
    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }));
    }
    handleFormData = (productFormData, productSectionData) => {
        const duplicateProductFlag = checkDulpicateProduct(productFormData, this.state.productData);
        if (duplicateProductFlag) {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Warning</ModalHeader>
                    <ModalBody>
                        <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Duplicate Product</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleModal}>Ok</Button>
                    </ModalFooter>   
                </div>,               
                initialValues: { ...productFormData },
            }))
        } else {
            let tempProductData = [...this.state.productData]
            const tempProductFormData = setProductFormData(productFormData, productSectionData, this.state.productId);
            tempProductData.push(tempProductFormData);
            this.setState(prevState => ({
                editProductFlag: false,
                productData: tempProductData,
                updateFlag: !prevState.updateFlag,
                selectedSectionData: [],
                initialValues: {
                    counterpartyType: '',
                    reportCategory: '',
                    reportFrontCover: '',
                    name: '',
                    price: 0,
                    turnAroundTime: ''
                },
                productDataCount: prevState.productDataCount + 1,
                productId: null
            }))
        }
    }    
    handleEditProduct = (event, productDataIndex) => {
        event.preventDefault();
        const tempProductData = [...this.state.productData];
        tempProductData.splice(productDataIndex, 1);
        this.setState(prevState => ({
            editProductFlag: true,
            productData: tempProductData,
            productId: prevState.productData[productDataIndex].id,
            updateFlag: !prevState.updateFlag,
            selectedSectionData: prevState.productData[productDataIndex].sectionList,
            crawlersData : prepareCrawlerData(prevState.productData[productDataIndex].crawlers),
            initialValues: {
                counterpartyType: prevState.productData[productDataIndex].counterpartyType,
                reportCategory: prevState.productData[productDataIndex].reportCategory,
                reportFrontCover: prevState.productData[productDataIndex].reportFrontCover,
                name: prevState.productData[productDataIndex].name,
                price: prevState.productData[productDataIndex].price,
                turnAroundTime: prevState.productData[productDataIndex].turnAroundTime,
                description: prevState.productData[productDataIndex].description,
                productType : (prevState.productData[productDataIndex].productType == "QUICK" ? true : false),
                shareable : prevState.productData[productDataIndex].shareable,
                databaseProduct : prevState.productData[productDataIndex].databaseProduct,
                reportType : prevState.productData[productDataIndex].reportType,
                productTitle : prevState.productData[productDataIndex].productTitle,
                productCategory : prevState.productData[productDataIndex].productCategory,
                creditLimitModels : prevState.productData[productDataIndex].creditLimitModels,
                standardProduct :prevState.productData[productDataIndex].standardProduct,
                standardProductCategory:prevState.productData[productDataIndex].standardProductCategory,
                standardProductSegment:prevState.productData[productDataIndex].standardProductSegment,
                clientVisible : prevState.productData[productDataIndex].clientVisible,

                //-----
            }
            
        }))
    }
    handleProductNextButton = (event) => {
        event.preventDefault();
        // if (this.state.productData.length > 0) {
        const validateData = validateProductData(this.state.productData, this.state.inputValue, this.props.corporateOnboardingStatus);
        if (validateData) {
            this.props.setProductSetup(this.state.productData);
            this.props.setCreditSetup(this.state.inputValue);
            this.props.activeProgressTab('setup-progress-element finished');
            this.props.history.push('../misfieldsetup');
        } else {
            this.setState(prevState => ({
                showModal: !prevState.showModal,
                body: <div>
                    <ModalHeader>Warning</ModalHeader>
                    <ModalBody>
                        <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Add Products To Continue or Add Credits</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleModal}>Ok</Button>
                    </ModalFooter>
                </div>
            }))
        }
    }
    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        Product Setup
                        </h5>
                </div>
                <Card>
                    <CardBody className="py-0">
                        <Row>
                            <Col sm="12" className="border-right py-3">
                                <ProductDetailsForm updateFlag={this.state.updateFlag}
                                    productFormDataCallback={this.handleFormData}
                                    initialValues={this.state.initialValues}
                                    counterpartyDropdown={this.props.counterPartyTypeDropdown}
                                    reportCategoryDropdownList={this.props.reportCategoryDropdown}
                                    reportFrontCoverDropdownList={this.props.reportFrontCoverDropdown}
                                    selectedSectionList={this.state.selectedSectionData} 
                                    crawlersData = {this.state.crawlersData}/>
                            </Col>
                            <Col sm="12" className="border-right py-3">
                                <section>
                                    <div className="header-blue p-3 text-primary font-weight-bold">Products [{this.state.productDataCount}]</div>
                                    <ul>
                                        {this.state.productData.map((p, index) => {
                                            if (p.enabled) {
                                                return (
                                                    <li key={p.name} className="pl-3 mb-3">
                                                        <Row key={p.name}>
                                                            <Col sm="6"><a href="javascript:void(0)" style={this.state.editProductFlag ? { pointerEvents: "none" } : null} onClick={(event) => this.handleEditProduct(event, index)}>{p.name}</a></Col>
                                                            <Col sm="4">{p.counterpartyType}</Col>
                                                            <Col sm="4">{p.sectionList.length} Sections</Col>
                                                            <Col sm="4">{p.turnAroundTime} days</Col>
                                                            <Col sm="3">{p.price}</Col>
                                                            <Col sm="2"><a href="javascript:void(0)"><i className="icon-close text-danger" onClick={(event) => this.handleDeleteProductData(event, index)}></i></a></Col>
                                                        </Row>
                                                    </li>
                                                )
                                            }
                                        })}
                                    </ul>
                                </section>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
                    <h5 className="mb-0">
                        Credit Setup
                        </h5>
                </div>
                <Card className="pb-70">
                    <CardBody>
                        {this.state.availableCredit ? <p><strong>Available Credit:</strong> {this.state.availableCredit}</p> : ""}
                        <Label>
                            Enter Credit Value
                            </Label>
                        <div className="input-group w-25 mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text p-2">₹</span>
                            </div>
                            <Input type="text" className="w-25 px-2" placeholder="Enter credit value" value={this.state.inputValue} onChange={this.updateInputValue} />
                        </div>
                    </CardBody>
                </Card>
                <footer className="bg-light footer w-100 text-center">
                    <Button color="primary" onClick={(event)=>this.handleProductNextButton(event)}>
                        Next
                        &nbsp;&nbsp;<i className="fa fa-angle-double-right"></i>
                    </Button>
                </footer>
                <Modal show={this.state.showModal} modalClosed={this.toggleModal} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
            </Col>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    counterPartyTypeDropdown: state.createCase.dropdownData,
    reportCategoryDropdown: state.createCase.reportCategorytData,
    reportFrontCoverDropdown: state.createCase.reportFrontCoverList,
    productDetailsForm: state.form.productDetailsForm,
    companySetupOnbaordingData: state.corporateOnBoardingCreate.companySetup,
    creditData: state.corporateOnBoardingCreate.creditSetup,
    incomingProductData: state.corporateOnBoardingCreate.productSetup,
    corporateOnboardingStatus: state.corporateOnBoardingCreate.corporateOnboardingStatus,
    editData: state.corporateOnBoardingCreate.editData
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    setProductSetup: (data) => { dispatch(setProductSetup(data)) },
    fetchCounterPartyType: () => dispatch(getCounterpartyType()),
    fetchReportCategory: () => dispatch(getreportCategory()),
    fetchReportFrontCoverList: () => { dispatch(getReportFrontCoverList()) },
    fetchSectionList: () => { dispatch(fetchSectionList()) },
    fetchCreditLimitModelList: () => { dispatch(fetchCreditLimitModelList()) },
    setCreditSetup: (data) => { dispatch(setCreditSetup(data)) },
});
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth(ProductSetup));
// export default ProductSetup;